module.exports = __webpack_public_path__ + "img/aman.6ebd1b02.png";